import { registerAction } from '../../../Action'

const ADD_VIEW_TO_STORE = 'ADD_VIEW_TO_STORE'

const reducer = (state = {}, data) => {
  const errors = state.errors || {}
  if (errors && data.payload.clearErrors) {
    delete errors[data.payload.view]
  }

  return {
    ...state,
    entityDataByView: {
      ...state.entityDataByView,
      [data.payload.view]: {},
    },
    ...errors,
  }
}

const addViewToStore = registerAction(ADD_VIEW_TO_STORE, { reducer })

export default addViewToStore
